module.exports = __webpack_public_path__ + "static/hyperv_36.c6cd9057.jpg";